import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const PermissionContext = createContext()

const PermissionProvider = ({ children }) => {

    const { auth, toast } = useAuth();

    const headers = {
        Authorization: auth?.token,
    };

    const getAllPermissions = async () => {
        try {
            let { data } = await axios.get(`${baseURL}/admin/permission/`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }
  
    const updatePermissions = async (permissions) => {
        try {
            let { data } = await axios.post(`${baseURL}/admin/permission/`, { permissions }, { headers })
            if (data.error === false) {
                setTimeout(function () {
                    toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                }, 500);
                return data.data;
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            console.log(error);
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    return (
        <PermissionContext.Provider value={{ getAllPermissions, updatePermissions }}>
            {children}
        </PermissionContext.Provider>
    )
}

const usePermission = () => useContext(PermissionContext)

export { usePermission, PermissionProvider, }